import React from 'react'
import ReactMarkdown from 'react-markdown'

interface Props {
  content: string
}

export const Markdown: React.FC<Props> = ({ content }) => {
  return <ReactMarkdown source={content} escapeHtml={true} />
}
